import { v4 as uuidv4 } from 'uuid';

import { Login } from '../../../../vtex-apps/login/Login/default';
import { RichText } from '../../../../vtex-apps/rich-text/RichText/default';
import { Image } from '../../../../vtex-apps/store-components/Image/default';
import { FlexLayoutCol, FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { Logo } from '../../../../vtex-apps/store-components/Logo/default';
import { SearchBar } from '../../../../vtex-apps/store-components/SearchBar/default';
import { StickyLayout } from '../../../../vtex-apps/sticky-layout/StickyLayout/default';
import { VisibilityLayout } from '../../../../vtex-apps/VisibilityLayout/default';

const HeaderDesktop = () => {
	return {
		componentName: 'HeaderDesktop',
		componentId: uuidv4(),
		componentGroup: 'HeaderDesktop',
		variables,
		props: {
			mzTitle: 'MZ | Header - Desktop',
			blockClass: 'mz-header-2',
		},
		childrenComponents: [
			StickyLayout({ blockClass: 'mz-header-2', position: 'top', verticalSpacing: 0 }, [
				FlexLayoutRow(
					{
						colSizing: 'equal',
						blockClass: 'mz-header-2-row-1',
						paddingTop: { desktop: 5, tablet: 5 },
						paddingBottom: { desktop: 5, tablet: 5 },
					},
					[
						FlexLayoutCol({ blockClass: 'mz-header-2-col-1' }, [SearchBar({ blockClass: 'mz-header-2' })]),
						FlexLayoutCol({ blockClass: 'mz-header-2-col-2' }, [
							Logo({
								width: 300,
								url: 'https://maeztra.com/wp-content/uploads/2020/09/logo_Prancheta-1.svg',
								href: '/',
								title: 'Logo',
								blockClass: 'mz-header-2',
							}),
						]),
						FlexLayoutCol({ blockClass: 'mz-header-2-col-3' }, [
							FlexLayoutRow(
								{
									colSizing: 'auto',
									fullWidth: true,
									blockClass: 'mz-header-2-col-3-row-1',
									horizontalAlign: 'between',
									colGap: { desktop: 5, tablet: 5 },
								},
								[
									Login({ iconLabel: 'Minha Conta', blockClass: 'mz-header-2' }),
									RichText({ text: '[Favoritos](/wishlist)', blockClass: 'mz-header-2-wishlist' }),
									{
										componentGroup: 'MinicartGroup',
										componentName: 'MinicartGroup',
										componentId: uuidv4(),
									},
								],
							),
						]),
					],
				),
				{
					componentGroup: 'StoreMenuDesktop',
					componentName: 'FlexLayoutRow',
					componentId: uuidv4(),
				},
			]),

			// VisibilityLayout({ visible: true, mzTitle: "Modal de cookies" }, [{ componentName: "CookieModal" }]),
			VisibilityLayout({ mzTitle: 'MZ | Botão Whatsapp (On/Off)' }, [
				FlexLayoutRow({ blockClass: 'mz-header-2-whats-float__flex-row' }, [
					Image({
						blockClass: 'mz-header-2-whatsapp-float-2__image',
						src: 'https://hefesto-upload-images.s3.amazonaws.com/1682006713447-1681501967650-WhatsApp.png',
					}),
					RichText({
						blockClass: 'mz-header-2-whatsapp-float-2__text',
						text: '[Atendimento](https://whts.co/)',
					}),
				]),
			]),
		],
	};
};

const variables = [
	{
		type: 'color',
		list: [
			{ from: '--white', to: '--header-desktop-2-bg-color', name: 'Header Background' },
			// { from: "--white", to: "--header-desktop-2-menu-bg-color", name: "Menu Background", },
			// { from: "--text-color-1", to: "--header-desktop-2-menu-text-color", name: "Menu Text", },
			// { from: "--neutral-color-high-medium", to: "--header-desktop-2-menu-line-color", name: "Menu Line", },
			{ from: '--text-color-1-dark', to: '--header-desktop-2-icons-color', name: 'Icons Text' },
			{ from: '--text-color-1-dark', to: '--header-desktop-2-search-text-color', name: 'Search Text' },
			{ from: '--text-color-1-dark', to: '--header-desktop-2-search-border-color', name: 'Search Border' },
			{ from: '--neutral-color-low-medium', to: '--header-desktop-2-search-button-color', name: 'Search Button' },

			{ from: '--transparent', to: '--header-desktop-2-search-bg-color', name: 'Search Background' },
			{
				from: '--text-color-1-dark',
				to: '--header-desktop-2-categories-border-color',
				name: 'All Categories Border',
			},
			//submenu text color
			// { from: "--text-color-1-dark", to: "--header-desktop-2-submenu-text-color", name: "Submenu Text", },
			//submenu
			// { from: "--white", to: "--header-desktop-2-submenu-bg-color", name: "Submenu", },
			//submenu border color
			// { from: "--text-color-1-dark", to: "--header-desktop-2-submenu-border-color", name: "Submenu Border", },
			//submenu item hover
			// { from: "--neutral-color-high-medium", to: "--header-desktop-2-submenu-item-hover-color", name: "Submenu Item Hover", },
			//minicart color
			{ from: '--support-color-3', to: '--header-desk-2-minicart-color', name: 'Minicart' },
			{ from: '--white', to: '--header-desk-2-minicart-text', name: 'Minicart Text' },
			{ from: '--support-color-3', to: '--header-desktop-2-whatsapp-bg-color', name: 'Whatsapp Background' },
			{
				from: '--support-color-3',
				to: '--header-desktop-2-whatsapp-bg-hover',
				name: 'Whatsapp Background Hover',
			},
			//search autocomplete
			{
				from: '--neutral-color-low-medium',
				to: '--header-desktop-2-search-autocomplete-text-color',
				name: 'Search Autocomplete Text',
			},
		],
	},
	{
		type: 'borderWidth',
		list: [
			// { from: "--border-width-hairline", to: "--header-desktop-2-submenu-width", name: "Submenu", },
			{ from: '--border-width-hairline', to: '--header-desktop-2-search-border-width', name: 'Search' },
			// { from: "--border-width-hairline", to: "--header-desktop-2-menu-line-width", name: "Menu line", },
			{ from: '--border-width-hairline', to: '--header-desktop-2-all-cat-width', name: 'All categories' },
		],
	},
	{
		type: 'borderRadius',
		list: [
			{ from: '--border-radius-sm', to: '--header-desktop-2-submenu-br', name: 'Submenu' },
			{ from: '--border-radius-none', to: '--header-desktop-2-all-categories-br', name: 'All categories' },
			{ from: '--border-radius-none', to: '--header-desktop-2-search-br', name: 'Search' },
			//login border radius
			{ from: '--border-radius-sm', to: '--header-desk-2-login-br', name: 'Login' },
			//whatsapp border radius
			{ from: '--border-radius-sm', to: '--header-desktop-2-whatsapp-br', name: 'Whatsapp' },
			//search autocomplete
			{
				from: '--border-radius-sm',
				to: '--header-desktop-2-search-autocomplete-br',
				name: 'Search Autocomplete',
			},
		],
	},
	{
		type: 'fontSize',
		list: [
			{ from: '--font-size-xs', to: '--header-desktop-2-icons-fs', name: 'Icons' },
			{ from: '--font-size-xs', to: '--header-desktop-2-search-fs', name: 'Search' },
			// { from: "--font-size-xs", to: "--header-desktop-2-menu-fs", name: "Menu", },
			//submenu text size
			// { from: "--font-size-xs", to: "--header-desktop-2-submenu-fs", name: "Submenu", },
			//search autocomplete
			{ from: '--font-size-xs', to: '--header-desktop-2-search-autocomplete-fs', name: 'Search Autocomplete' },
		],
	},
	{
		type: 'fontWeight',
		list: [
			{ from: '--font-weight-400', to: '--header-desktop-2-icons-fw', name: 'Icons' },
			{ from: '--font-weight-400', to: '--header-desktop-2-search-fw', name: 'Seach' },
			// { from: "--font-weight-400", to: "--header-desktop-2-menu-fw", name: "Menu font weight", },
			//submenu
			// { from: "--font-weight-400", to: "--header-desktop-2-submenu-fw", name: "Submenu", },
		],
	},
	{
		type: 'spacing',
		list: [
			// { from: "--spacing-atom", to: "--header-desktop-2-submenu-gap", name: "Submenu Items Gap" },
			//submenu lateral padding
			// { from: "--spacing-sm", to: "--header-desktop-2-submenu-lateral-padding", name: "Submenu Lateral Padding" },
		],
	},
];

export default HeaderDesktop;
